import { type TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface InfoBoxSignature {
  Args: {
    type: 'info' | 'warning' | 'error';
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

<template>
  <div class={{bem (hash type=@type)}} ...attributes>
    {{yield}}
  </div>
</template> satisfies TOC<InfoBoxSignature>;
